import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the money of the given `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#customlineitem"
        }}>{`CustomLineItem`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changeCustomLineItemMoney"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`customLineItemId`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`ID of an existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#customlineitem"
          }}>{`CustomLineItem`}</a>{` in the cart.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`money`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#money"
          }}>{`Money`}</a>{` - Required`}<br parentName="li"></br>
          {`The new money.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      